import styled from 'styled-components';

export const HeaderContainer = styled.header`
    position: sticky;
    top: 0;
    background-color: #282828;
    padding: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1000;
`;

export const LogoContainer = styled.div`
    align-items: center;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    background: linear-gradient(135deg, #ff6b8b, #6b5bff);
    box-shadow: 0 8px 20px #6b5bff66;
    height: 80px;
    width: 80px;
    overflow: hidden;
    position: relative;
    margin: 0;
    flex-shrink: 0;
    padding: 4px;

    @media (max-width: 768px) {
        height: 70px;
        width: 70px;
    }

    img {
        background-color: #2c2c2c;
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
    }
`;

export const NavContainer = styled.nav`
    ul {
        list-style: none;
        display: flex;
        gap: 1rem;
        margin: 0;
        padding: 0;
    }

    a {
        text-decoration: none;
        font-weight: bold;
        background: linear-gradient(90deg, #ff6b8b, #6b5bff);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
    }

    @media (max-width: 768px) {
        ul {
            display: none;
            flex-direction: column;
            position: absolute;
            top: 100%;
            left: 0;
            width: 100%;
            background-color: #282828d9;
            padding: 1rem;
        }

        &.active ul {
            display: flex;
        }
    }
`;

export const HamburgerMenu = styled.div`
    display: none;
    flex-direction: column;
    gap: 4px;
    cursor: pointer;

    div {
        width: 25px;
        height: 3px;
        background-color: white;
    }

    @media (max-width: 768px) {
        display: flex;
    }
`;